module.exports = __webpack_public_path__ + "static/media/map-tervuren.eba03917.png";